import "./app/common/filter-table-global/filter-table-global.component.js";
import "./app/common/filter-table-global/filter-table-global.controller.js";
import "./app/common/filters/parse-address-receiver/parse-address-receiver.filter.js";
import "./app/common/filters/truncate/truncate.filter.js";
import "./app/common/obj-converter/obj-converter.service.js";
import "./app/common/print-label/print-label.service.js";
import "./app/common/receiver-parser/receiver-panel/receiver-panel.controller.js";
import "./app/common/receiver-parser/receiver-parser.component.js";
import "./app/common/receiver-parser/receiver-parser.controller.js";
import "./app/common/shipping-config/shipping-config.resource.js";
import "./app/common/shipping-config/shipping-config.service.js";
import "./app/common/spec/utils/utils.module.js";
import "./app/finalizar-cadastro/documento/documento.controller.js";
import "./app/finalizar-cadastro/endereco/endereco.controller.js";
import "./app/finalizar-cadastro/finalizar-cadastro.route.js";
import "./app/finalizar-cadastro/finalizar-cadastro.service.js";
import "./app/finalizar-cadastro/gasto-mensal/gasto-mensal.controller.js";
import "./app/finalizar-cadastro/terms/terms.component.js";
import "./app/finalizar-cadastro/terms/terms.controller.js";
import "./app/finalizar-cadastro/terms/terms.service.js";
import "./app/historico/charts/charts.component.js";
import "./app/finalizar-cadastro/update-terms/update-terms.component.js";
import "./app/finalizar-cadastro/update-terms/update-terms.controller.js";
import "./app/historico/charts/charts.controller.js";
import "./app/historico/pedido/historico-numero.controller.js";
import "./app/historico/pedido/historico-pedido-cancelado/historico-pedido-cancelado.controller.js";
import "./app/historico/pedido/historico-pedido-confirmacao/historico-pedido-confirmacao.controller.js";
import "./app/historico/pedido/historico-pedido-empacotamento/historico-pedido-empacotamento.controller.js";
import "./app/historico/pedido/historico-pedido-envio/historico-pedido-envio.controller.js";
import "./app/historico/pedido/historico-pedido-fora-area/historico-pedido-fora-area.controller.js";
import "./app/historico/pedido/historico-pedido-incompleto/historico-pedido-incompleto.controller.js";
import "./app/historico/pedido/historico-pedido-localizacao/historico-pedido-localizacao-template.controller.js";
import "./app/historico/pedido/historico-pedido-localizacao/historico-pedido-localizacao.controller.js";
import "./app/historico/pedido/historico-pedido-retirada/historico-pedido-retirada.controller.js";
import "./app/historico/pedido/historico-pedido.controller.js";
import "./app/historico/pedidos/historico-pedidos-controller.js";
import "./app/history/history-controller.js";
import "./app/history/history-encomendas.controller.js";
import "./app/history/history.component.js";
import "./app/history/history.js";
import "./app/relatorios/relatorio-sla.route.js";
import "./app/history/packages-list/details-panel/base-panel.controller.js";
import "./app/history/packages-list/details-panel/details.controller.js";
import "./app/history/packages-list/filter-panel/delivery-filter.controller.js";
import "./app/history/packages-list/filter-panel/filter-visible.controller.js";
import "./app/history/packages-list/filter-panel/status-filter.controlller.js";
import "./app/history/packages-list/manual-registration/manual-registration.js";
import "./app/history/packages-list/packages-list.component.js";
import "./app/history/packages-list/packages-list.controller.js";
import "./app/history/packages-list/packages-menu/menu-actions.controller.js";
import "./app/history/packages-list/status-panel/edit-panel.controller.js";
import "./app/history/packages-list/status-panel/notfound-panel.controller.js";
import "./app/history/reverse/reverse-form/cancel-panel/cancel-panel.controller.js";
import "./app/history/reverse/reverse-form/new-recipient-address/new-recipient-address.controller.js";
import "./app/history/reverse/reverse-form/reverse-form.component.js";
import "./app/history/reverse/reverse-form/reverse-form.controller.js";
import "./app/history/reverse/reverse-form-v2/reverse-form-v2.component.js";
import "./app/history/reverse/reverse-form-v2/reverse-form-v2.controller.js";
import "./app/history/reverse/reverse-list/delete-panel/delete-panel.controller.js";
import "./app/history/reverse/reverse-list/details-panel/base-panel.controller.js";
import "./app/history/reverse/reverse-list/details-panel/details.controller.js";
import "./app/history/reverse/reverse-list/filter-panel/delivery-filter.controller.js";
import "./app/history/reverse/reverse-list/filter-panel/status-filter.controlller.js";
import "./app/history/reverse/reverse-list/origin-panel/origin-panel.controller.js";
import "./app/history/reverse/reverse-list/reverse-list.component.js";
import "./app/history/reverse/reverse-list/reverse-list.controller.js";
import "./app/modal/modal-black-friday/modal-black-friday.controller.js";
import "./app/modal/modal-bloqueio-por-horario/modal-bloqueio-por-horario.controller.js";
import "./app/modal/modal-fora-area/modal-fora-area.controller.js";
import "./app/modal/modal-servico-suspenso/modal-servico-suspenso.controller.js";
import "./app/modal/modal-soft-disabled/modal-soft-disabled.controller.js";
import "./app/modal/modal-welcome/modal-welcome.controller.js";
import "./app/pedido/coleta/coleta.directive.js";
import "./app/pedido/coleta/coleta.service.js";
import "./app/pedido/coleta/liberacao-coleta.controller.js";
import "./app/pedido/encomenda/encomenda-adicionar.controller.js";
import "./app/pedido/encomenda/encomenda-editar.controller.js";
import "./app/pedido/encomenda/encomenda.controller.js";
import "./app/pedido/encomenda/encomenda.resource.js";
import "./app/pedido/encomenda/encomenda.service.js";
import "./app/pedido/importacao-planilha/upload/upload.controller.js";
import "./app/pedido/mercado-livre/mercado-livre.controller.js";
import "./app/pedido/package-parser.service.js";
import "./app/pedido/pagamento/pagamento.controller.js";
import "./app/pedido/pagamento/pagamento.service.js";
import "./app/pedido/pedido.controller.js";
import "./app/pedido/pedido.js";
import "./app/pedido/resumo/resumo.pedido.controller.js";
import "./app/pedido/veiculo/modal-area-postagem.controller.js";
import "./app/pedido/veiculo/veiculo.controller.js";
import "./app/perfil/api-config/api-config.component.js";
import "./app/perfil/api-config/api-config.controller.js";
import "./app/perfil/integration/integration-config/integration-config.component.js";
import "./app/perfil/integration/integration-config/integration-config.controller.js";
import "./app/perfil/integration/modal/integration-modal.controller.js";
import "./app/perfil/perfil-redirecionar.controller.js";
import "./app/perfil/perfil.route.js";
import "./app/perfil/redirecionar/redirecionar.controller.js";
import "./app/rastreamento/rastreamento.controller.js";
import "./app/rastreamento/rastreamento.js";
import "./components/address-control/address-control.directive.js";
import "./components/address-control/modal-delete/modal-delete.controller.js";
import "./components/address-control/modal-msg/modal-msg.controller.js";
import "./components/alert/alert.service.js";
import "./components/directives/add-shadow-on-scroll.js";
import "./components/directives/capitalize-first.js";
import "./components/directives/capitalize.js";
import "./components/directives/click-once.js";
import "./components/directives/copy-to-clipboard.js";
import "./components/directives/finishedRepeat.js";
import "./components/directives/focus-me.js";
import "./components/directives/logout.js";
import "./components/directives/smart-banner.js";
import "./components/directives/mandae-cpf-cnpj-mask.directive.js";
import "./components/directives/string-to-number.js";
import "./components/directives/up-to-top.directive.js";
import "./components/directives/update-title.js";
import "./components/etiqueta/etiqueta.controller.js";
import "./components/file-upload/upload.resource.js";
import "./components/file-upload/upload.service.js";
import "./components/filter-actions/filter-table-actions.component.js";
import "./components/filter-actions/filter-table-actions.controller.js";
import "./components/filters/add-span.filter.js";
import "./components/filters/capitalize.filter.js";
import "./components/filters/cep.filter.js";
import "./components/filters/credit-card.filter.js";
import "./components/filters/document.filter.js";
import "./components/filters/endereco.filter.js";
import "./components/filters/enderecoJS.filter.js";
import "./components/filters/my-format-date.filter.js";
import "./components/filters/notEmpty.filter.js";
import "./components/filters/plural.filter.js";
import "./components/filters/prazo.filter.js";
import "./components/filters/qrcodes.filter.js";
import "./components/filters/string-correios.filter.js";
import "./components/home-bar/notification-bar.directive.js";
import "./components/home-bar/notification-bar.service.js";
import "./components/import-sales/bulk-actions/bulk-actions.controller.js";
import "./components/import-sales/bulk-actions/delivery-dialog.controller.js";
import "./components/import-sales/bulk-actions/document-dialog.controller.js";
import "./components/import-sales/bulk-actions/insurance-dialog.controller.js";
import "./components/import-sales/edit-sale-form/edit-sale-form.component.js";
import "./components/import-sales/edit-sale-form/edit-sale-form.controller.js";
import "./components/import-sales/filter-menu/filter-menu.controller.js";
import "./components/import-sales/filter-shipping/filter-shipping.controller.js";
import "./components/import-sales/import-sales.component.js";
import "./components/import-sales/import-sales.controller.js";
import "./components/import-sales/import-sales.directive.js";
import "./components/includes/loading.controller.js";
import "./components/infra/resource/area.resource.js";
import "./components/infra/resource/cep.resource.js";
import "./components/infra/resource/endereco.resource.js";
import "./components/infra/resource/orcamento.resource.js";
import "./components/infra/resource/parametro.resource.js";
import "./components/infra/services/cep.service.js";
import "./components/infra/services/endereco.service.js";
import "./components/infra/services/orcamento.service.js";
import "./components/infra/services/parametro.service.js";
import "./components/infra/services/utils.service.js";
import "./components/isMobile/is-mobile.js";
import "./components/modal/modal.service.js";
import "./components/price-simulator/modal/modal.controller.js";
import "./components/price-simulator/price-simulator.component.js";
import "./components/price-simulator/price-simulator.controller.js";
import "./components/shipping-options/select-shipping-options.component.js";
import "./components/smartbanner/smartbanner.js";
import "./components/tracking-bar/tracking-bar.directive.js";
import "./components/tracking-bar/tracking-bar.resource.js";
import "./components/tracking-bar/tracking-bar.service.js";
import "./components/valor-declarado/max-limit.directive.js";
import "./components/valor-declarado/min-limit.directive.js";
import "./components/valor-declarado/valor-declarado.component.js";
import "./services/analytics/rdstation.service.js";
import "./services/cliente/cliente.resource.js";
import "./services/cliente/cliente.service.js";
import "./services/financeiro/financeiro.resource";
import "./services/financeiro/financeiro.service";
import "./services/integration/integration.resource.js";
import "./services/integration/integration.service.js";
import "./services/integration/mercado-livre.resource.js";
import "./services/integration/mercado-livre.service.js";
import "./services/integration/paypal.resource.js";
